import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { SSO, SSO_EXCHANGE } from '../constants/apiRoutes';
import { postUnauth } from './onwardClient';
import { authorizeUrl, claimSsoSecrets, issueSsoSecrets, readAuthorizationResponse } from './oauthRedirect';
import { clearImpersonation } from '@/utilities/impersonation';

// One endpoint on two keys -- the deep link has a tenant and no email, the login page the reverse.
// Issuer, client id and authorize endpoint all come from the backend, so no provider name reaches
// this bundle, and the casing each key needs is the schema's job there rather than ours here.
export const fetchSso = async (type) => {
    const { data } = await postUnauth(SSO, { type });

    return data;
};

// Null on any failure: a lookup that cannot complete must not block the password flow.
export const fetchSsoByEmail = async (email) => {
    try {
        const { data } = await postUnauth(SSO, { email });

        return data?.enabled ? data : null;
    } catch {
        return null;
    }
};

const requireEnabled = (sso) => {
    if (!sso?.enabled) {
        throw new Error('SSO is not enabled');
    }
};

const EXCHANGE_REFUSED =
    'We could not complete your sign-in. Your Onward access has most likely not been set up yet — ask your IT administrator, or contact Onward support.';
const EXCHANGE_UNREACHABLE = 'We could not reach Onward to finish signing you in. Please try again.';

// The code is redeemed on the backend, which holds the client secret; the verifier travels with
// it there and nowhere else.
export const startSsoLogin = async (sso) => {
    requireEnabled(sso);

    window.location.assign(authorizeUrl(sso, await issueSsoSecrets()));
};

export const completeSsoCallback = async (type) => {
    const { search } = window.location;

    // First statement, before the await and before anything can throw: the refusal is the URL a user
    // screenshots. State is passed through because React Router keeps its history index in it.
    window.history.replaceState(window.history.state, '', window.location.pathname);

    const sso = await fetchSso(type);

    requireEnabled(sso);

    const { code, state } = readAuthorizationResponse(search);
    const { nonce, code_verifier } = claimSsoSecrets(state);

    // The endpoint answers every refusal with a bare 401, so any other status is an outage of ours
    // rather than anything the user's IT can act on.
    const { data } = await postUnauth(`${SSO_EXCHANGE}/${sso.type}`, { code, nonce, code_verifier }).catch((error) => {
        throw new Error(error.response?.status === 401 ? EXCHANGE_REFUSED : EXCHANGE_UNREACHABLE);
    });

    clearImpersonation();
    await signInWithCustomToken(getAuth(), data.token);
};
